export default __webpack_public_path__ + "images/e1a4c9b1d6475fe6bd05997aef538402-food_sub_small.webp";